import Discussion from "../../Tweets/discussion/Discussion";
import Gender from "../../Tweets/gender/Gender";
import Media from "../../Tweets/media/Media";
import Sentiment from "../../Tweets/sentiment/Sentiment";
import SentimentXeno from "../../Tweets/sentimentxeno/SentimentXeno";

import "./Migracion.css";

// eslint-disable-next-line no-unused-vars
import { Divider, Popover, Select, Typography } from "antd";

import TEXT from "../../../utils/text/prensa.json";

// eslint-disable-next-line no-unused-vars
import { InfoCircleOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { useCurrentLanguage } from "../../../hooks/useCurrentLanguage";
import { getCsvData } from "../../../utils/functions/getCsvData";

const { Option } = Select;
// eslint-disable-next-line no-unused-vars
const { Text, Title } = Typography;

// eslint-disable-next-line no-unused-vars
const Circle = ({ size, color }) => {
  const calculatedSize = 50 + size * 100; // Base size of 50px, add up to 100px based on the value

  console.log("SIZE", calculatedSize);
  return (
    <div
      className="circle"
      style={{
        width: `${calculatedSize}px`,
        height: `${calculatedSize}px`,
        backgroundColor: color,
      }}
    >
      <p>{parseInt(size * 100)}%</p>
    </div>
  );
};

// eslint-disable-next-line no-unused-vars
const CircleLegend = ({ color, text }) => {
  return (
    <div className="circle-legend">
      <div
        className="circle"
        style={{
          backgroundColor: color,
          width: "10px",
          height: "10px",
          marginBottom: "auto",
        }}
      ></div>
      <p>{text}</p>
    </div>
  );
};

const Circles = ({ data, selectedCountry }) => {
  const language = useCurrentLanguage().language;
  // eslint-disable-next-line no-unused-vars
  const colors = ["#2E73B8", "#35AFC8", "#A48CCF", "#A6CE7A", "#F2C94C"];

  //sort data descending
  data.sort((a, b) => b - a);

  // eslint-disable-next-line no-unused-vars
  const [dataCountriesMentioned, setDataCountriesMentioned] = useState([]);

  useEffect(() => {
    const proccessDataCountriesMentioned = async () => {
      let dfCountries = await getCsvData(
        "/data/frequency/country_frequency_by_year_trimester.csv"
      );

      //filter rows by country and then return an array of the 5 lines with the max in row percentage
      let dataCountries = dfCountries
        .filter(
          (row) =>
            row.country ===
            (selectedCountry === "LAC" ? "LATAM" : selectedCountry)
        )
        .reduce((acc, row) => {
          if (acc[row.list_concepts]) {
            acc[row.list_concepts]["mentions"] += parseInt(
              row.articles_with_mention
            );
            acc[row.list_concepts]["total"] += parseInt(row.total_articles);
          } else {
            acc[row.list_concepts] = {
              mentions: parseInt(row.articles_with_mention),
              total: parseInt(row.total_articles),
            };
          }
          return acc;
        }, {});

      let countriesArray = Object.keys(dataCountries)
        .map((key) => {
          return {
            country: language === "en" ? key : TEXT["countries"][key],
            percentage: dataCountries[key].mentions / dataCountries[key].total,
          };
        })
        .sort((a, b) => b.percentage - a.percentage)
        .slice(0, 5);

      console.log("DATA COUNTRIES", countriesArray);

      setDataCountriesMentioned(countriesArray);
    };
    proccessDataCountriesMentioned();
  }, [selectedCountry, language]);

  return (null);
  /*return (
    <div>
      <div className="title-container">
        <Title
          level={2}
          style={{ color: "var(--lightblue-primary)", textAlign: "center" }}
        >
          {TEXT["mentions"]["circles"]["title"][language]}
        </Title>

        <div className="flex">
          <Title
            level={3}
            style={{ color: "var(--blue-primary)", textAlign: "center" }}
          >
            {dataCountriesMentioned.length !== 0
              ? dataCountriesMentioned[0].country
              : ""}{" "}
            {TEXT["mentions"]["circles"]["text"][language]}{" "}
            {selectedCountry === "LAC"
              ? "América Latina y el Caribe"
              : selectedCountry}
          </Title>
          <Popover
            content={
              <div
                style={{
                  width: "500px",
                  padding: "5px 16px 4px",
                  textAlign: "justify",
                }}
              >
                <Text>{TEXT["indicadores"]["circles1"][language]}</Text>
              </div>
            }
            title={language === "en" ? "Methodology" : "Metodología"}
            placement="leftTop"
          >
            <InfoCircleOutlined
              style={{
                fontSize: "20px",
                color: "var(--grey-primary)",
                opacity: "0.8",
                marginRight: "10px",
              }}
            />
          </Popover>
        </div>
      </div>

      <div className="circles-container">
        {dataCountriesMentioned.map((value, index) => (
          <Circle key={index} size={value.percentage} color={colors[index]} />
        ))}
      </div>
      <div className="circles-legend">
        {dataCountriesMentioned.map((value, index) => {
          return (
            <CircleLegend
              key={index}
              color={colors[index]}
              text={`${value.country}`}
            />
          );
        })}
      </div>
    </div>
  );*/
};

export default function Migracion({
  selectedCountry,
  countryName,
  countries,
  showSection,
  setMediaImg1,
  setMediaImg2,
  setDiscussionImg,
  setDiscussionImg2,
  setDiscussionImg3,
  setDiscussionImg4,
  setDiscussionImg5,
  setDiscussionImg6,
  setSentimentImg,
  setSentimentImg2,
  setSentimentImg3,
  setSentimentImg4,
  setComparisonImg,
  COUNTRY_OPTIONS,
  handleSelectChange,
  handleDownloadReport,
  isMediosSelected,
  isDiscussionSelected,
  isSentimentSelected,
  isComparisonSelected,
  mediosOnClick,
  discussionOnClick,
  sentimentOnClick,
  comparisonOnClick,
}) {
  const { language } = useCurrentLanguage();

  return (
    <>
      <div className="data-page-select-container">
        <div className="data-page-select-content">
          <div className="data-page-search-caption">
            <strong>{TEXT["searchByCountry"][language]}</strong>
          </div>
          <Select
            className="data-page-select"
            value={selectedCountry ?? "LAC"}
            onChange={handleSelectChange}
          >
            {COUNTRY_OPTIONS.map((country, key) => {
              return (
                <Option key={key} value={country.code}>
                  {language === "en"
                    ? country.country_text_en
                    : country.country_text}
                </Option>
              );
            })}
          </Select>
        </div>
      </div>

      {selectedCountry && selectedCountry !== "LAC" && (
        <h1 className="data-page-country-title">
          {
            COUNTRY_OPTIONS.find((co) => selectedCountry === co.code)[
              language === "en" ? "country_text_en" : "country_text"
            ]
          }
        </h1>
      )}

      {/* <BIDButton
            text={miscTEXT["downloadLatestReport"][language]}
            type={"light"}
            size={"medium"}
            onClick={handleDownloadReport}
            /> */}

      {/* kpis */}
      {/* <div className="prensa-kpis">
            <div className="prensa-kpi-container">
                <div className="prensa-kpi-icon-container">
                    <FileFilled className="prensa-kpi-icon"/>
                </div>
                <div className="prensa-kpi-value-container">
                    <p className="prensa-kpi-value">768</p>
                    <p className="prensa-kpi-increase">+ 2.5%</p>
                </div>
                <p className="prensa-kpi-title">Noticias migratorias</p>
            </div>
            <div className="prensa-kpi-container">
                <div className="prensa-kpi-icon-container">
                    <CheckSquareFilled className="prensa-kpi-icon"/>
                </div>
                <div className="prensa-kpi-value-container">
                    <p className="prensa-kpi-value">206</p>
                    <p className="prensa-kpi-decrease">- 2.5%</p>
                </div>
                <p className="prensa-kpi-title">Noticias positivas</p>
            </div>
            <div className="prensa-kpi-container">
                <div className="prensa-kpi-icon-container">
                    <MinusSquareFilled className="prensa-kpi-icon"/>
                </div>
                <div className="prensa-kpi-value-container">
                    <p className="prensa-kpi-value">562</p>
                    <p className="prensa-kpi-increase">+ 2.5%</p>
                </div>
                <p className="prensa-kpi-title">Noticias negativas</p>
            </div>
            <div className="prensa-kpi-container">
                <div className="prensa-kpi-icon-container">
                    <WarningFilled className="prensa-kpi-icon"/>
                </div>
                <div className="prensa-kpi-value-container">
                    <p className="prensa-kpi-value">34</p>
                    <p className="prensa-kpi-decrease">- 2.5%</p>
                </div>
                <p className="prensa-kpi-title">Fuentes</p>
            </div>
        </div> */}

      {/* <div className="data-page-index">
            <div
            className={
                "data-page-index-button" +
                (isMediosSelected ? " darker-selected" : "")
            }
            >
            <BIDButton
                size={"medium"}
                text={
                <div className="data-page-logo-container">
                    <ConversationIcon />
                    {TEXT["volume"][language]}
                </div>
                }
                onClick={mediosOnClick}
            />
            </div>
            <div
            className={
                "data-page-index-button" +
                (isDiscussionSelected ? " darker-selected" : "")
            }
            >
            <BIDButton
                size={"medium"}
                text={
                <div className="data-page-logo-container">
                    <XenophobiaIcon />
                    {TEXT["topics"][language]}
                </div>
                }
                onClick={discussionOnClick}
            />
            </div>
            <div
            className={
                "data-page-index-button" +
                (isSentimentSelected ? " darker-selected" : "")
            }
            >
            <BIDButton
                size={"medium"}
                text={
                <div className="data-page-logo-container">
                    <SentimentIcon />
                    {TEXT["sentiment"][language]}
                </div>
                }
                onClick={sentimentOnClick}
            />
            </div>
            <div
            className={
                "data-page-index-button" +
                (isComparisonSelected ? " darker-selected" : "")
            }
            >
            <BIDButton
                size={"medium"}
                text={
                <div className="data-page-logo-container">
                    <XenophobiaIcon />
                    {TEXT["amplification"][language]}
                </div>
                }
                onClick={comparisonOnClick}
            />
            </div>
        </div> */}
      <div
        id="sentiment-section"
        className={
          "data-page-section" +
          (showSection("medios") ? "" : " data-page-hidden")
        }
      >
        <Media
          selectedCountry={selectedCountry}
          setImg1={setMediaImg1}
          setImg2={setMediaImg2}
          countryName={countryName}
          countries={countries}
          countryOptions={COUNTRY_OPTIONS}
        />
      </div>
      <Divider className="divider-full-screen" />
      <div
        id="sentiment-section"
        className={
          "data-page-section" +
          (showSection("sentiment") ? "" : " data-page-hidden")
        }
      >
        <Sentiment
          selectedCountry={selectedCountry}
          countryName={countryName}
          countries={countries}
          countryOptions={COUNTRY_OPTIONS}
          setImg1={setSentimentImg}
          setImg2={setSentimentImg2}
          setImg3={setSentimentImg3}
          setImg4={setSentimentImg4}
        />
      </div>
      <Divider className="divider-full-screen" />
      <div
        id="sentiment-section"
        className={
          "data-page-section" +
          (showSection("topics") ? "" : " data-page-hidden")
        }
      >
        <Discussion
          selectedCountry={selectedCountry}
          countryName={countryName}
          countryOptions={COUNTRY_OPTIONS}
          setImg1={setDiscussionImg}
          setImg2={setDiscussionImg2}
          setImg3={setDiscussionImg3}
          setImg4={setDiscussionImg4}
          setImg5={setDiscussionImg5}
          setImg6={setDiscussionImg6}
        />
      </div>
      <Divider className="divider-full-screen" />
      <div
        id="sentiment-section"
        className={
          "data-page-section" +
          (showSection("gender") ? "" : " data-page-hidden")
        }
      >
        <Gender
          selectedCountry={selectedCountry}
          countryName={countryName}
          countryOptions={COUNTRY_OPTIONS}
          setImg1={setDiscussionImg}
          setImg2={setDiscussionImg2}
          setImg3={setDiscussionImg3}
          setImg4={setDiscussionImg4}
          setImg5={setDiscussionImg5}
          setImg6={setDiscussionImg6}
        />
      </div>
      <Divider className="divider-full-screen" />
      <SentimentXeno
        selectedCountry={selectedCountry}
        countryName={countryName}
        countries={countries}
        countryOptions={COUNTRY_OPTIONS}
        setImg1={setDiscussionImg}
        setImg2={setDiscussionImg2}
        setImg3={setDiscussionImg3}
        setImg4={setDiscussionImg4}
        setImg5={setDiscussionImg5}
        setImg6={setDiscussionImg6}
      />
      <Divider className="divider-full-screen" />
      <Circles
        data={[0.35, 0.68, 0.59, 0.64, 0.56]}
        selectedCountry={selectedCountry}
      />
      {/* <div
            id="sentiment-section"
            className={
                "data-page-section" +
                (showSection("amplification") ? "" : " data-page-hidden")
            }
            >
            <div className="data-page-section-title">
                {TEXT["amplification"][language]}
            </div>
            <Comparison selectedCountry={selectedCountry} countryName={countryName} setImg1={setComparisonImg}/>
        </div> */}
    </>
  );
}
